import {Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, Inject} from '@angular/core';
import { ABWToastService } from 'src/app/shared/helpers/abw-toast.service';
import { Model_Datasource, AbwDatasourceProviderItem, AbwDatasourceColumn, AbwDatasourceParams, TYPE_DATASOURCE, StartupInfos_Datasource, AbsPaginatedGrid, TYPE_DEFAULT_VALUE, AbwDatasourceJointure, SOURCE_COLONNE } from 'src/app/app.models';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DatasourceFormModalPage } from '../datasource-form-modal/datasource-form-modal.page';
import { AbwDatatableComponent } from '../../abw-datatable/abw-datatable.component';
import { DatasourceService } from 'src/app/core-api/services/datasource/datasource.service';
import { AbwConfirmDialogService } from '../../abw-confirm-dialog/abw-confirm-dialog.service';
import { DatasourceFiltersDialogComponent } from '../../workflow-components/datasource-picker/datasource-filters-dialog/datasource-filters-dialog.component';
import { DatasourceDesignerJointureModalComponent } from './datasource-designer-jointure-modal/datasource-designer-jointure-modal.component';
import { DatasourceDesignerColumnFormModal } from './datasource-designer-column-form-modal/datasource-designer-column-form-modal.component';
import { DatasourceDesignerEditDatasModal } from './datasource-designer-edit-datas-modal/datasource-designer-edit-datas-modal.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { DatasourceOrdersDialogComponent } from '../../workflow-components/datasource-picker/datasource-orders-dialog/datasource-orders-dialog.component';

export enum DESIGNER_MODE {
    CREATION_MODE = 1,
    SELECTION_MODE = 2
}

@Component({
    selector: 'app-datasource-designer',
    templateUrl: './datasource-designer.modal.html',
    styleUrls: ['./datasource-designer.modal.scss']
})
export class DatasourceDesignerModal implements OnInit, AfterViewInit {
    errString: string = null;
    loading = false;
    datasource = new Model_Datasource();
    startupInfos: StartupInfos_Datasource;
    datasourceProviderItem = new AbwDatasourceProviderItem();
    datasourceColumns: AbwDatasourceColumn[] = [];
    modalResult?: Model_Datasource;
    filteredDatasources: Model_Datasource[] = [];
    startupDesignerMode = DESIGNER_MODE.CREATION_MODE;
    currentDesignerMode = DESIGNER_MODE.CREATION_MODE;
    SOURCE_COLONNE = SOURCE_COLONNE;
    DESIGNER_MODE = DESIGNER_MODE;
    TYPE_DATASOURCE = TYPE_DATASOURCE;
    searchFormControl = new FormControl();
    
    absGrid = new AbsPaginatedGrid();
    @ViewChild('datatable') datatable: AbwDatatableComponent;

    constructor(
        public _datasourceService: DatasourceService,
        private _toastrService: ABWToastService,
        private _dialog: MatDialog,
        private cdf: ChangeDetectorRef,
        private _confirmDialogService: AbwConfirmDialogService,
        public dialogRef: MatDialogRef<DatasourceDesignerModal>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        if (!!data.designerMode) {
            this.currentDesignerMode = data.designerMode;
            this.startupDesignerMode = data.designerMode;
        }
        if (!!data.startupInfos) {
            this.startupInfos = data.startupInfos;
        }
        if (!!data.datasource) {
            this.datasource = data.datasource;
        }
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        var promise = Promise.resolve<void>(null);
        if (!this.startupInfos) {
            promise = this._doGetStartupInfos();
        }
        promise.then(() => {
            if (!!this.datasource.NUM_DATASOURCE) {
                this.onDatasourceSelected(this.currentDesignerMode == DESIGNER_MODE.CREATION_MODE ?{ value: this.datasource.NUM_DATASOURCE } : { detail: { value: this.datasource.NUM_DATASOURCE } });
                this.doBuildGrid(this.datasource);
            }
    
            if (!!this.datasource && !!this.datasource.DS_PARAMS && !!this.datasource.DS_PARAMS.DS_COLUMNS) {
                this.datasourceColumns = this.datasource.DS_PARAMS.DS_COLUMNS;
            }
            this.cdf.detectChanges();
        });
        this.searchFormControl.valueChanges.pipe(debounceTime(300)).subscribe((_searchText: string) => {
            this._doFilterDatas(_searchText);
        });
    }

    goInCreationMode() {
        this.currentDesignerMode = DESIGNER_MODE.CREATION_MODE;
    }

    dismiss() {
        if (this.startupDesignerMode == DESIGNER_MODE.SELECTION_MODE && this.currentDesignerMode == DESIGNER_MODE.CREATION_MODE) {
            this.currentDesignerMode = DESIGNER_MODE.SELECTION_MODE;
        } else {
            return this.dialogRef.close();
        }
    }

    onDatasourceSelected(_event: any) {
        if (!this.startupInfos) { return; }
        const value = this.currentDesignerMode == DESIGNER_MODE.CREATION_MODE ? _event?.value : _event.detail?.value;
        const datasource = this.startupInfos.datasources.find(d => d.NUM_DATASOURCE == value);
        if (!datasource) { return; }

        const datasourceProviderItem = this.startupInfos.datasourceProviders[datasource.TYPE_DATASOURCE]?.find(t => t.name == datasource.DS_PARAMS.name);
        if (!!datasourceProviderItem) {
            this.datasourceProviderItem = datasourceProviderItem;
        }

        this.datasource = datasource;
        this.datasourceColumns = this.datasource.DS_PARAMS.DS_COLUMNS;
        this.doBuildGrid(this.datasource);
    }

    async openColumnFormModal(_column?: AbwDatasourceColumn) {
        const dialogRef = this._dialog.open(DatasourceDesignerColumnFormModal, {
            data: {
                column: _column,
                startupInfos: this.startupInfos,
                datasource: this.datasource,
                datasourceColumns: this.datasourceColumns,
                datasourceProviderItem: JSON.parse(JSON.stringify(this.datasourceProviderItem)),
                isUpdate: !!_column
            },
            width: '30%'
        });
      
        dialogRef.afterClosed().subscribe((_result?: { column: AbwDatasourceColumn, continue: boolean }) => {
            if (!_result) { return; }

            const columIndex = this.datasourceColumns.findIndex(c => c.name == _result.column.name);
            if (columIndex > -1) {
                this.datasourceColumns[columIndex] = _result.column;
            } else {
                this.datasourceColumns.push(_result.column);
            }
            this.doSaveDatasourceAction();

            if (_result.continue) {
                this.openColumnFormModal();
            }
        });
    }

    async removeColumnAction(_column: AbwDatasourceColumn) {
        const confirmResult = await this._confirmDialogService.showConfirmDialog('Suppression Colonne [' + _column.name + ']', "Voulez-vous vraiment supprimer cette colonne ?");
        if (confirmResult === true) {
            const columIndex = this.datasourceColumns.findIndex(c => c.name == _column.name);
            if (columIndex > -1) {
                this.datasourceColumns.splice(columIndex, 1);
                this.doSaveDatasourceAction();
            }
        }
    }

    async doCreateDatasource() {
        const dialogRef = this._dialog.open(DatasourceFormModalPage, {
            data: {
                startupInfos: this.startupInfos,
            },
            width: '95vw',
            panelClass: 'datasource-designer-modal'
        });
      
        dialogRef.afterClosed().subscribe((data?: Model_Datasource) => {
            if (!data) { return; }
            this.startupInfos.datasources.push(data);
            this.currentDesignerMode = DESIGNER_MODE.CREATION_MODE;
            this.onDatasourceSelected(this.currentDesignerMode == DESIGNER_MODE.CREATION_MODE ?{ value: data.NUM_DATASOURCE } : { detail: { value: data.NUM_DATASOURCE } });
        });
    }

    async doOpenEditDatasModal() {
        const dialogRef = this._dialog.open(DatasourceDesignerEditDatasModal, {
            data: {
                datasource: JSON.parse(JSON.stringify(this.datasource)),
            },
            width: '95vw',
            panelClass: 'datasource-designer-modal'
        });
      
        dialogRef.afterClosed().subscribe((data?: Model_Datasource) => {
            if (!data) { return; }
            this.datasource = data;
            this.doBuildGrid(this.datasource);
        });
    }

    doSaveDatasourceAction() {
        if (this.currentDesignerMode != DESIGNER_MODE.CREATION_MODE) { return; }

        this.loading = true;
        this.errString = null;
        if (!this.datasource.DS_PARAMS) { this.datasource.DS_PARAMS = new AbwDatasourceParams(); }
        if (this.datasource.TYPE_DATASOURCE == TYPE_DATASOURCE.STATIC && this.datasource.IS_LOCKED == false && !!this.datatable?.datas?.mPagination?.mDatas) { 
            this.datasource.DS_PARAMS.datas = this.datatable.datas.mPagination.mDatas; 
        }
        this.datasource.DS_PARAMS.DS_COLUMNS = this.datasourceColumns;
        this._datasourceService.doSaveDatasourceAction(this.datasource).subscribe(_datasourceSaved => {
            this.loading = false;
            this._toastrService.showToast('La source de données a été enregistrée.', 'Abworkflow');
            this.doBuildGrid(this.datasource);
        }, (error: string) => {
            //this._toastrService.showToast(error);
            this.loading = false;
            this.errString = error;
        })
    }

    doBuildGrid(_datasource: Model_Datasource) {
        this.loading = true;
        this.errString = null;
        this._datasourceService.doBuildGridDatasource(_datasource, true).then((_buildedDatasource: { Columns: any[], AbsGrid: AbsPaginatedGrid<any> }) => {
            this.absGrid = _buildedDatasource.AbsGrid;
            this.loading = false;
        }, (error: string) => {
            //this._toastrService.showToast(error);
            this.loading = false;
            this.errString = error;
        });
    }

    doValidateSelection() {
        if (!this.datasource.DS_PARAMS.DS_COLUMNS) {
            this.datasource.DS_PARAMS.DS_COLUMNS = this.datasourceColumns;
        }
        this.dialogRef.close(this.datasource);
    }

    private _doGetStartupInfos() {
        return new Promise<void>((resolve, reject) => {
            this.loading = true;
            this.errString = null;
            this._datasourceService.doGetStartupInfosAction().subscribe(_startupInfos => {
                this.startupInfos = _startupInfos;
                this._doFilterDatas(this.searchFormControl.value);
                this.loading = false;
                resolve();
            }, (error: string) => {
                //this._toastrService.showToast(error);
                this.loading = false;
                this.errString = error;
                reject(error);
            });
        });
    }

    async openDatasourceFiltersDialog() {
        const dialogRef = this._dialog.open(DatasourceFiltersDialogComponent, {
            data: {
                datasource: { 
                    TITRE: this.datasource.TITRE, 
                    DS_COLUMNS: this.datasource.DS_PARAMS.DS_COLUMNS,
                    DS_FILTERS: this.datasource.DS_PARAMS.DS_FILTERS.map(filterItem => ({
                        DATASOURCE_COLUMN: filterItem.FilterColumn,
                        TYPE_DEFAULT_VALUE: filterItem.FilterOperator,
                        DEFAULT_VALUE: filterItem.FilterValue
                    })),
                    DS_ORDERS:  this.datasource.DS_PARAMS.DS_ORDERS || []
                },
            },
            width: '95vw',
            panelClass: 'datasource-designer-modal'
        });
        
        dialogRef.afterClosed().subscribe((_result?: any) => {
            if (!_result) { return; }
            this.datasource.DS_PARAMS.DS_FILTERS = _result.DS_FILTERS.map(filterItem => ({ 
                FilterColumn: filterItem.DATASOURCE_COLUMN,
                FilterOperator: filterItem.TYPE_OPERANDE == 'eq' ? "=" : filterItem.TYPE_OPERANDE,
                FilterValue: filterItem.DEFAULT_VALUE
            }));

            this.doSaveDatasourceAction();
        });

    }

    async openDatasourceOrdersDialog() {
        const dialogRef = this._dialog.open(DatasourceOrdersDialogComponent, {
            data: {
                datasource: { 
                    TITRE: this.datasource.TITRE, 
                    DS_COLUMNS: this.datasource.DS_PARAMS.DS_COLUMNS,
                    DS_FILTERS: this.datasource.DS_PARAMS.DS_FILTERS.map(filterItem => ({
                        DATASOURCE_COLUMN: filterItem.FilterColumn,
                        TYPE_DEFAULT_VALUE: filterItem.FilterOperator,
                        DEFAULT_VALUE: filterItem.FilterValue
                    })),
                    DS_ORDERS:  this.datasource.DS_PARAMS.DS_ORDERS || []
                },
            },
            width: '30%'
        });
        
        dialogRef.afterClosed().subscribe((_result?: any) => {
            if (!_result) { return; }
            this.datasource.DS_PARAMS.DS_ORDERS = [{ OrderColumn: _result.OrderColumn, OrderDirection: _result.OrderDirection }];
            this.doSaveDatasourceAction();
        });
    }

    async clearDatasourceOrdersAction() {
        const confirm = await this._confirmDialogService.showConfirmDialog('Source de données', 'Voulez-vous vraiment supprimer les tries sur la source de données ?');
        if (confirm) {
            this.datasource.DS_PARAMS.DS_ORDERS = [];
            this.doSaveDatasourceAction();
        }
    }

    async openJointureModal() {
        const dialogRef = this._dialog.open(DatasourceDesignerJointureModalComponent, {
            data: {
                activeDatasource: this.datasource,
                datasources: this.startupInfos.datasources.filter(d => /*d.IS_LOCKED === true && */d.NUM_DATASOURCE != this.datasource.NUM_DATASOURCE), 
            },
            width: '30%',
        });
      
        dialogRef.afterClosed().subscribe((dsJoin?: any) => {
            if (!dsJoin) { return; }
            if (!this.datasource.DS_PARAMS.DS_JOINTURES) { this.datasource.DS_PARAMS.DS_JOINTURES = []; }
            this.datasource.DS_PARAMS.DS_JOINTURES.push(dsJoin);

            this.doSaveDatasourceAction();
        });
    }

    async removeJointureAction(_jointure: AbwDatasourceJointure) {
        if (this.datasource.DS_PARAMS.DS_COLUMNS.filter(c => c.numDatasource == _jointure.NUM_DATASOURCE).length > 0) {
            this._toastrService.showToast("Suppression impossible: veuillez rétirer les colonnes jointes avant de pouvoir supprimer la jointure.");
            return;
        }
        
        const confirmResult = await this._confirmDialogService.showConfirmDialog('Suppression Jointure', "Voulez-vous vraiment supprimer cette jointure ?");
        if (confirmResult === true) {
            const columIndex = this.datasource.DS_PARAMS.DS_JOINTURES.findIndex(c => c.NUM_DATASOURCE == _jointure.NUM_DATASOURCE);
            if (columIndex > -1) {
                this.datasource.DS_PARAMS.DS_JOINTURES.splice(columIndex, 1);
                this.doSaveDatasourceAction();
            }
        }
    }

    getDatasourceByNum(numDatasource: string) {
        return this.startupInfos.datasources.find(d => d.NUM_DATASOURCE == numDatasource);
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.datasourceColumns, event.previousIndex, event.currentIndex);
        this.doSaveDatasourceAction();
    }

    private _doFilterDatas(_searchText?: string) {
        this.filteredDatasources = this.startupInfos.datasources;
        if (!!_searchText) {
            this.filteredDatasources = this.filteredDatasources.filter(row => {
                return row.TITRE.toLowerCase().indexOf(_searchText.toLowerCase()) !== -1;
            });
        }
    }
}